import React from 'react';
import { ActivityIcon, FootprintsIcon, CalendarXIcon } from 'lucide-react';
const pains = [{
  icon: ActivityIcon,
  text: 'El dolor punzante en las rodillas después de una bajada larga.'
}, {
  icon: FootprintsIcon,
  text: 'El miedo a doblarte un tobillo porque no tenés estabilidad.'
}, {
  icon: CalendarXIcon,
  text: 'Entrenar 6 días a la semana y sentir que seguís siendo igual de lento en los senderos.'
}];
export function PainAgitation() {
  return <section aria-labelledby="dolor-titulo" className="w-full border-t border-line bg-panel py-20 sm:py-28" data-id="element-84" data-mp="td4yclh2ph0x">
      <div className="mx-auto max-w-5xl px-4" data-id="element-85" data-mp="181soudc2b0k0">
        <h2 id="dolor-titulo" className="max-w-2xl font-display text-3xl font-bold uppercase leading-tight tracking-tight text-bone sm:text-4xl" data-id="element-86" data-mp="183lxtza5dwv6">
          Correr en trail no es solo «correr por el pasto»
        </h2>

        <ul className="mt-12 divide-y divide-line border-y border-line" data-id="element-87" data-mp="1c3w319q48j8z">
          {pains.map(({
          icon: Icon,
          text
        }) => <li key={text} className="flex items-start gap-4 py-6" data-id="element-88" data-mp="1t8ityldycb4b">
              <Icon aria-hidden="true" className="mt-0.5 h-5 w-5 shrink-0 text-clay" data-id="element-89" data-mp="1y5silytioir3" />
              <p className="text-lg leading-relaxed text-bone/85" data-id="element-90" data-mp="235ol1tmkg24j">{text}</p>
            </li>)}
        </ul>

        <div className="mt-12 max-w-2xl" data-id="element-91" data-mp="284rsfkq0qkfo">
          <p className="text-lg leading-relaxed text-mute" data-id="element-92" data-mp="285t5tvuibj0k">
            La mayoría de los planes allá afuera te piden que sumes «kilómetros basura».
          </p>
          <p className="mt-4 font-display text-2xl font-bold uppercase leading-tight text-lime sm:text-3xl" data-id="element-93" data-mp="2h44s5locbun7">
            Yo te propongo algo diferente: entrenar con inteligencia, no con volumen.
          </p>
        </div>
      </div>
    </section>;
}